import React from 'react';
import PropTypes from 'prop-types';
import FeaturedBrands from './FeaturedBrands';


const FeaturedCategoriesList = function FeaturedCategoriesListComponent({ categories }) {
  return categories.map(category => (
    <div
      key={category.id}
      className="homepage-category__wrapper"
    >
      <div
        className="homepage-category"
      >
        <a
          href={category.url}
          className="homepage-category__link"
        >
          <div
            className="homepage-category__image"
            style={{ backgroundImage: `url(${category.image})` }}
          />

          <div className="homepage-category__info">
            <h3 className="homepage-category__title">
              {category.name}
            </h3>
            <p className="homepage-category__description">
              {category.shortDescription}
            </p>
          </div>
        </a>

        <div className="homepage-category__brands-wrapper">
          <h3 className="homepage-category__brands__title">Featured Brands</h3>
          <div className="homepage-category__brands">
            <FeaturedBrands brands={category.featuredBrands} />
          </div>
        </div>
      </div>
    </div>
  ));
};

export default FeaturedCategoriesList;

FeaturedCategoriesList.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    image: PropTypes.string,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    shortDescription: PropTypes.string.isRequired,
    featuredBrands: PropTypes.arrayOf(PropTypes.shape({})),
  })).isRequired,
};
